import { createContext, useState, Dispatch, SetStateAction } from "react";

const GlobalBannerContext = createContext<{
  globalBanner: null | string;
  globalBannerType: "info" | "attention" | "critical" | "new" | "success" | undefined;
  setGlobalBanner: Dispatch<SetStateAction<null | string>>;
  setGlobalBannerType: Dispatch<SetStateAction<"info" | "attention" | "critical" | "new" | "success" | undefined>>;
}>({
  globalBanner: null,
  globalBannerType: undefined,
  setGlobalBanner: () => {}, //eslint-disable-line @typescript-eslint/no-empty-function
  setGlobalBannerType: () => {}, //eslint-disable-line @typescript-eslint/no-empty-function
});

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const GlobalBannerProvider = ({ children }: { children: React.ReactNode }) => {
  const [globalBanner, setGlobalBanner] = useState<null | string>("");
  const [globalBannerType, setGlobalBannerType] = useState<"info" | "attention" | "critical" | "new" | "success" | undefined>(undefined);

  return (
    <GlobalBannerContext.Provider value={{ globalBanner, setGlobalBanner, globalBannerType, setGlobalBannerType }}>
      {children}
    </GlobalBannerContext.Provider>
  );
};

export { GlobalBannerProvider, GlobalBannerContext };
